import React, { Component } from "react";

import logo from "images/custom/login/login_graphic.png";

class LoginImageRow extends Component {
  render() {
    return (
      <div className="innerblock pure-g">
        <div className="pure-u-1-6 pure-u-sm-1-3" />
        <div className="pure-u-2-3 pure-u-sm-1-3 bottommargin">
          <img src={logo} alt="" className="imgresponsive" />
        </div>
        <div className="pure-u-1-6 pure-u-sm-1-3" />
      </div>
    );
  }
}

export default LoginImageRow;
